const siteName = 'up-otel-hkg-ymt';
let config = require('./' + siteName + '-' + process.env.NODE_ENV + '-config.json');
if (process.env.NODE_ENV === 'DEV') {
  config = require('./' + siteName + '-' + process.env.NODE_ENV + '-config.json');
};
module.exports = config;
